import { createAction, props } from '@ngrx/store';

import LogoGroupContract = Microsoft.VideoIndexer.Contracts.Customization.LogoGroupContract;

export const logoGroupsLoad = createAction('[LogoGroups/API] Load Logo groups');
export const loadLogoGroupFailed = createAction('[LogoGroups] Fail load Logo Groups');
export const loadLogoGroupsInProgress = createAction('[LogoGroups] Load Logo Groups In Progress');
export const loadLogoGroupsSuccess = createAction('[LogoGroups] Upsert Logo Groups', props<{ groups: LogoGroupContract[] }>());
export const clearLogoGroups = createAction('[LogoGroups] Clear Logo Groups');
